// action
export const INITIAL_BEGIN = '@initial/INITIAL_BEGIN';